import {
  delDelegate,
  getDelegates,
  postDelegate,
  putDelegate,
} from "./delegates";
import { getSettings, putSettings } from "./settings";

const user = {
  delegates: {
    delDelegate,
    getDelegates,
    postDelegate,
    putDelegate,
  },
  settings: {
    getSettings,
    putSettings,
  },
};

export { user };
